import React from 'react';

/**
 * LoadingSpinner — WareShare-branded loader.
 *
 * Was a plain Reactstrap `<Spinner>` on the default `primary` tone
 * (Bootstrap blue). Now a single-ring ticker driven by the theme's
 * `--ws-brand-primary`, so an admin who overrides the palette at
 * /settings/branding gets the same treatment here for free.
 *
 * Props intentionally kept name-compatible with the old API so the
 * existing ~100 call sites don't need touching.
 */
const LoadingSpinner = ({ fullPage = false, text = 'Loading…' }) => {
  const className = fullPage
    ? 'ws-spinner-wrap'
    : 'd-flex align-items-center justify-content-center py-3';
  return (
    <div className={className} role="status" aria-live="polite">
      <div className="ws-spinner" aria-hidden="true" />
      {text ? (
        <span className={fullPage ? '' : 'ms-2 text-muted'}>{text}</span>
      ) : null}
    </div>
  );
};

export default LoadingSpinner;
